'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('waiting', {
            url: '/waiting',
            templateUrl: 'waiting/waiting.html',
            controller: 'waitingCtrl as ctrl'
        });
};
